import { z } from 'zod'
import { parseTaxRatePercent } from '../helpers/tax.js'

/**
 * Sales tax as a percent, up to three decimal places and no higher than 100.
 *
 * "8.25" and "8.250" are the same rate. The money pattern is the wrong check
 * here: a rate keeps a third decimal, and a dollar amount does not.
 */
export const taxRatePercentSchema = z.string().refine(
  (value) => parseTaxRatePercent(value) !== null,
  'Enter a tax rate as a percent, up to 100',
)
